import Appsignal from "@appsignal/javascript";

// These keys are explicitly safe to embed in frontend JS
const KEYS = {
  production: "bf70ed8a-6b70-4f26-9b72-3953fa95d448",
  staging: "9fbf9e93-b756-45d5-8485-60cfad55be73",
};

function deployEnvironment() {
  const hostname = location.hostname;

  if (hostname === "www.rrr.org.au") {
    return "production";
  } else if (/^staging/.test(hostname)) {
    return "staging";
  } else if (/localhost/.test(hostname)) {
    // ignore dev
  } else {
    console.warn("unknown hostname, cannot set appsignal namespace:", hostname);
  }
}

function createAppsignal(namespace) {
  const key = KEYS[deployEnvironment()];
  if (!key) {
    return null;
  }

  return new Appsignal({
    key,
    namespace,
    // eslint-disable-next-line no-undef
    revision: process.env.ASSETS_GIT_REVISION,
  });
}

export function setupAppsignal(namespace) {
  window._appsignal = createAppsignal(namespace);

  window.addEventListener("error", (ev) => {
    if (window._appsignal) {
      window._appsignal.sendError(ev, span => {
        span.setTags({ unhandled: "true" });
      })
    }
  });
}

function decorateError(error) {
  if (error instanceof Error) {
    // try to decorate error name with message
    try {
      error.name = `${error.name}: ${error.message}`;
    } catch (e) {}

    return error;
  } else {
    // appsignal requires that errors are an instance of Error (or ErrorEvent)
    const wrapped = new Error(error);

    // set name to original error
    try {
      wrapped.name = `${error}`;
    } catch (e) {}

    return wrapped;
  }
}

function shouldIgnoreError(error) {
  if (!error) {
    return false;
  }

  // This appears to be something to do with Outlook 365 Safe Links scanning.
  // No clearer idea than that. It's just noise, drop it.
  if (error.name === "TypeError" && error.message.includes("elm.events.push is not a function")) {
    return true;
  }

  return false;
}

export function reportError(error) {
  if (shouldIgnoreError(error)) {
    return;
  }

  // log error first before anything else might get thrown:
  console.error(error);

  if (window._appsignal) {
    window._appsignal.sendError(decorateError(error));
  }
}
